import React from 'react';
import styles from '../../styles/EstudiantesStyles/Estudiantes.module.css';

function SearchSection({ programa, programas = [], onProgramaChange, searchTerm, onSearchChange, onSearch, onRegister, canRegister = false, readOnly = false }) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className={styles.searchSection}>
      <div className={styles.searchCard}>
        <div className={styles.searchRow}>
          <div className={styles.formGroup}>
            <label className={styles.searchLabel}>Programa</label>
            <select 
              className={styles.searchSelect}
              value={programa}
              onChange={(e) => onProgramaChange(e.target.value)}
            >
              <option value="">Todos los programas</option>
              {programas.map((prog) => (
                <option key={prog.id_programa} value={prog.id_programa}>
                  {prog.nombre_programa}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.searchInputGroup}>
            <svg className={styles.searchIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="#898d8d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Buscar Estudiante por Matrícula o Nombre"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>

          <button className={styles.buscarButtonEstudiantes} onClick={onSearch}>
            Buscar
          </button>

          {canRegister && !readOnly && (
            <button
              type="button"
              className={styles.newProgramButton}
              onClick={onRegister}
            >
              + Registrar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchSection;
